import { Fragment, useContext } from "react";
import {
  PageHeading,
  TableOfContents,
  Mui,
  TOC,
  MuiStyles
} from "@osu/react-ui";
import Routes from "../../Routes/components";

const createClasses = (theme) => {
  return {
    root: {
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'row-reverse'
      },
      minHeight: "calc(100vh - var(--nav-height) - var(--footer-height))"
    },
    toc: {
      zIndex: 10, //this needs to be lower than NavBar(appBar) which is set to 11 
    },
  };
};

function Main(props = defaultProps) {
  const { unauthorized, loading, spacingTop, ...rest } = props;
  const theme = MuiStyles.useTheme()
  const mdUp = Mui.useMediaQuery(theme => theme.breakpoints.up('md'));
  const classes = createClasses(theme);
  const { exists } = useContext(TOC.Context);
  const maxWidth = "xl";
  return (
      <Mui.Box flexGrow={100} sx={classes.root} {...rest}>
        {mdUp && <TableOfContents
            spacingTop={spacingTop}
            PaperProps={{
              sx: classes.toc,
            }}
            StylizedLinkProps={{ color: "primary" }}
          />}
        <Mui.Container className="margin-y-4" maxWidth={maxWidth}>
          {
            mdUp 
              ? <PageHeading tabIndex="" />
              : <Fragment>
                <header className="display-flex">
                  <PageHeading tabIndex="" />
                </header>
                {exists && <TableOfContents variant="popover" />}
              </Fragment>
          }
          <Routes />
        </Mui.Container>
      </Mui.Box>
  );
}

const defaultProps = {
  className: "",
  tabIndex: "-1",
  component: "main",
};

export default Main